import { css } from "@emotion/react";
import colors from "assets/css/colors";
import fontFamily from "assets/css/fontFamily";
import fontSize from "assets/css/fontSize";
import fontWeight from "assets/css/fontWeight";

export const datePickerWrapperCss = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
  input {
    box-sizing: border-box;
    width: 100%;
    height: 32px;
    padding: 10px 32px 10px 12px;
    border: 1px solid ${colors.strokeGrey};
    border-radius: 4px;
    background-color: ${colors.white};
    font-family: ${fontFamily.roboto};
    &:focus {
      outline: none;
      border: 1px solid ${colors.mainBlue};
    }
    &::placeholder {
      color: #b7b7b7;
      opacity: 1;
    }
  }
  .react-datepicker__close-icon {
    &::after {
      background-color: transparent;
      font-size: 18px;
      color: black;
    }
    &:hover::after {
      opacity: 0.5;
    }
  }
`;

export const labelCss = css`
  display: block;
  font-size: ${fontSize.sm};
  font-weight: ${fontWeight.medium};
  color: ${colors.textGrey};
  line-height: 19.6px;
`;
